import styled from "styled-components";

const DefaultContainer = styled.div`
  width: 1200px;
  padding: 0 40px;
  box-sizing: border-box;
`;

export default DefaultContainer;
